import script from "./FormDaftarRiwayatHidup.vue?vue&type=script&setup=true&lang=js"
export * from "./FormDaftarRiwayatHidup.vue?vue&type=script&setup=true&lang=js"

import "./FormDaftarRiwayatHidup.vue?vue&type=style&index=0&id=2c5a6c58&lang=css"

const __exports__ = script;

export default __exports__